import React, { useState, useRef, useEffect, useContext } from 'react';
import axios from 'axios';
import { useLocation  } from 'react-router-dom';
import $ from 'jquery';
import { MyContext } from './MyContextProvider'; // Import your context
import { useParams,useNavigate  } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import JsBarcode from 'jsbarcode';
import QRCode from "qrcode";
import './Core_Due_Diligence_Checklist.css';

const Core_Due_Diligence_Checklist = (props) => {
  const didFetchRef = useRef(false);
  const initRef = useRef({ headerHandled: false, dataTableHandled: false });

  const { i18n } = useTranslation();
  const { t } = useTranslation();
  var location = useLocation();
  const { App_Data, setApp_Data } = useContext(MyContext); // Access the context
  const urlParams = new URLSearchParams(window.location.search);
  //setReturn_Path(urlParams.get('Return'));
  const navigate = useNavigate();

  const inputFontStyle = {
    fontFamily: 'sans-serif',
    fontSize: '16px',
    fontWeight: 'normal',
    fontStyle: 'normal',
    color: '#000'
  };


  const [newData, setNewData] = useState({
 	Source_Path:"CORE_DUE_DILIGENCE_CHECKLIST",
    Status: App_Data.Status,
    Parameter: App_Data.Parameter,
    Search: App_Data.Search,
    Return_Path: App_Data.Return_Path,
    Return_ID: App_Data.ID,
    Return_Status: App_Data.Return_Status,
	Object_Text:";",
	CORE_DUE_DILIGENCE_CHECKLIST:-1
  });


  const [CORE_DUE_DILIGENCE_CHECKLIST, setCORE_DUE_DILIGENCE_CHECKLIST] = React.useState(null);
  const [CORE_DUE_DILIGENCE_CHECKLIST_D, setCORE_DUE_DILIGENCE_CHECKLIST_D] = React.useState(null);



 
  useEffect(() => {
    document.title = "SRWAE | "+t('Core Due Diligence Checklist');  
	  
 
	if(location.hash=="#Return"){
		setNewData({ ...newData});
		setApp_Data({ ...newData})
		navigate('/Core_Due_Diligence_Checklist',{replace:true});
	}
	if(location.hash=="#New"){
		const collectClientInfo = () => {
		return {
			userAgent: navigator.userAgent,
			language: navigator.language,
			platform: navigator.platform,
			screenResolution: `${screen.width}x${screen.height}`,
			colorDepth: screen.colorDepth,
			timezoneOffset: new Date().getTimezoneOffset(),
			timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
			cookieEnabled: navigator.cookieEnabled,
			javaEnabled: navigator.javaEnabled(),
			online: navigator.onLine,
			referrer: document.referrer,
			locationHref: window.location.href,
			screenOrientation: screen.orientation?.type || 'unknown'
		  };
		};

		const clientInfo = collectClientInfo();
		handleLoadNewCORE_DUE_DILIGENCE_CHECKLIST(clientInfo,"OpenNew");

		navigate('/Core_Due_Diligence_Checklist',{replace:true});
	}
	if(location.hash=="#Search"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/Core_Due_Diligence_Checklist_S',{replace:true});
	}
	if(location.hash=="#Update"){
		var Temp_Data2 =  JSON.parse(JSON.stringify(CORE_DUE_DILIGENCE_CHECKLIST));
		if(Temp_Data2.status!="New"){
			Temp_Data2.status = "UpToDate";
			handlePutCORE_DUE_DILIGENCE_CHECKLIST(Temp_Data2);
		}else{
			Temp_Data2.status = "UpToDate";
			handlePostCORE_DUE_DILIGENCE_CHECKLIST(Temp_Data2);
			const collectClientInfo = () => {
			  return {
				userAgent: navigator.userAgent,
				language: navigator.language,
				platform: navigator.platform,
				screenResolution: `${screen.width}x${screen.height}`,
				colorDepth: screen.colorDepth,
				timezoneOffset: new Date().getTimezoneOffset(),
				timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
				cookieEnabled: navigator.cookieEnabled,
				javaEnabled: navigator.javaEnabled(),
				online: navigator.onLine,
				referrer: document.referrer,
				locationHref: window.location.href,
				screenOrientation: screen.orientation?.type || 'unknown'
			  };
			};

			const clientInfo = collectClientInfo();
			handleLoadNewCORE_DUE_DILIGENCE_CHECKLIST(clientInfo,"OpenNew");
		}
		navigate('/Core_Due_Diligence_Checklist',{replace:true});
	}
	if(location.hash=="#FormPreview"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/Core_Due_Diligence_Checklist_P',{replace:true});
	}
	if(location.hash=="#SearchPreview"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/Core_Due_Diligence_Checklist_S_P',{replace:true});
	}
	if(location.hash=="#Print"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/Core_Due_Diligence_Checklist_P',{replace:true});
	}
	if(location.hash=="#Delete"){
		var Temp_Data2 =  JSON.parse(JSON.stringify(CORE_DUE_DILIGENCE_CHECKLIST));
		if(Temp_Data2.status!="New"){
			handleDeleteCORE_DUE_DILIGENCE_CHECKLIST(Temp_Data2);
			navigate('/Core_Due_Diligence_Checklist#New',{replace:true});
		} 
		else 
			navigate('/Core_Due_Diligence_Checklist',{replace:true});
	}
	if(location.hash=="#Export"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/Core_Due_Diligence_Checklist',{replace:true});
	}
	if(location.hash=="#Import"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/Core_Due_Diligence_Checklist',{replace:true});
	}
	if(location.hash=="#Help"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/Core_Due_Diligence_Checklist',{replace:true});
	}
	if(location.hash=="#LogInLogOut"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/Core_Due_Diligence_Checklist',{replace:true});
	}


  }, [location.hash]);   // Use cleanup for location.hash such as }, [location.hash]);



  useEffect(() => {
	  
	    if (!CORE_DUE_DILIGENCE_CHECKLIST) return;

    if (!initRef.current.headerHandled) {
	  for (let i = 1; i <= 10; i++) {
	  const sectionId = `#PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_${i}_SECTION`;
	  const headerId = `#PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_${i}_HEADER`;

	  if ($(sectionId).length && $(headerId).length) {
		
		const hiddenSections = [0];
		if (hiddenSections.includes(i)) {
		  $(sectionId).hide();
		} else {
		  $(sectionId).show();
		}

		$(headerId).off("click").on("click", function () {
		  $(sectionId).slideToggle();

		  const icon = $(this).find(".toggle-icon");
		  const current = icon.text().trim();

		  if (current === "v") {
			icon.text("^");
		  } else {
			icon.text("v");
		  }
		});
	  }
	}
      initRef.current.headerHandled = true;
  }


  if (!initRef.current.dataTableHandled) {
    if ($('#Table2').length > 0) window.DataTableScript('#Table2');
    if ($('#Table3').length > 0) window.DataTableScript('#Table3');
    if ($('#Table4').length > 0) window.DataTableScript('#Table4');

    initRef.current.dataTableHandled = true;
  }  

  }, [CORE_DUE_DILIGENCE_CHECKLIST]) ;


  
  
  var Ids = [];
  for(var Ele in CORE_DUE_DILIGENCE_CHECKLIST){
	  for(var Sec in CORE_DUE_DILIGENCE_CHECKLIST[Ele]){
		if(Sec == "id")
			Ids.push(CORE_DUE_DILIGENCE_CHECKLIST[Ele]["id"]);
		else if(Sec == "status")
			Ids.push(CORE_DUE_DILIGENCE_CHECKLIST[Ele]["status"]);
		else if(Array.isArray(CORE_DUE_DILIGENCE_CHECKLIST[Ele][Sec]))
			  for(var Row in CORE_DUE_DILIGENCE_CHECKLIST[Ele][Sec])  // Convert to CORE_DUE_DILIGENCE_CHECKLIST[Ele][Sec].forEach((row) => { ... })
				for (var Id in Row) 
					Ids.push(Id);
		else
			for (var Id in CORE_DUE_DILIGENCE_CHECKLIST[Ele][Sec]) 
				Ids.push(Id);
	  }
  }
  const [isValid, setIsValid] = useState(Object.fromEntries(Ids.map(key => [key, true])));
   
   
  React.useEffect(() => {
	if (didFetchRef.current) return;
    didFetchRef.current = true;

	var Temp_Data= JSON.parse(JSON.stringify(App_Data));
	Temp_Data["CORE_DUE_DILIGENCE_CHECKLIST"] = 0;
	setApp_Data({...Temp_Data})

	const collectClientInfo = () => {
	  return {
		userAgent: navigator.userAgent,
		language: navigator.language,
		platform: navigator.platform,
		screenResolution: `${screen.width}x${screen.height}`,
		colorDepth: screen.colorDepth,
		timezoneOffset: new Date().getTimezoneOffset(),
		timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
		cookieEnabled: navigator.cookieEnabled,
		javaEnabled: navigator.javaEnabled(),
		online: navigator.onLine,
		referrer: document.referrer,
		locationHref: window.location.href,
		screenOrientation: screen.orientation?.type || 'unknown',
	  };
	};
	const baseClientInfo = collectClientInfo();
	handleLoadNewCORE_DUE_DILIGENCE_CHECKLIST(baseClientInfo,"FirstLoad");
 
/*	axios.get(`https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/CORE_DUE_DILIGENCE_CHECKLIST`).then((response1) => {
		if(!CORE_DUE_DILIGENCE_CHECKLIST) 
			setCORE_DUE_DILIGENCE_CHECKLIST(JSON.parse(JSON.stringify(response1.data)));
		axios.get(`https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/CORE_DUE_DILIGENCE_CHECKLIST_D`).then((response2) => {
			setCORE_DUE_DILIGENCE_CHECKLIST_D( JSON.parse(JSON.stringify(response2.data)));
			handleAddCORE_DUE_DILIGENCE_CHECKLIST_Load_Add_New(response1.data,response2.data);
		});
    });
*/

	//$('#navbarNav1').hide();
//$('#navbarNav6').hide();

  }, []);


 const handleLoadNewCORE_DUE_DILIGENCE_CHECKLIST = async (clientInfo, status) => {
	axios.post('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/CORE_DUE_DILIGENCE_CHECKLIST/New', {clientInfo, clientStamp: Date.now(), status:status})
	  .then(response => {
		setCORE_DUE_DILIGENCE_CHECKLIST(response.data);
	  })
	  .catch(error => {
		console.error('Error sending client info:', error);
	  });
  };



   

 const handleLastDataCORE_DUE_DILIGENCE_CHECKLIST = async (data) => {
	const collectClientInfo = () => {
	return {
		userAgent: navigator.userAgent,
		language: navigator.language,
		platform: navigator.platform,
		screenResolution: `${screen.width}x${screen.height}`,
		colorDepth: screen.colorDepth,
		timezoneOffset: new Date().getTimezoneOffset(),
		timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
		cookieEnabled: navigator.cookieEnabled,
		javaEnabled: navigator.javaEnabled(),
		online: navigator.onLine,
		referrer: document.referrer,
		locationHref: window.location.href,
		screenOrientation: screen.orientation?.type || 'unknown'
	  };
	};
	
	const clientInfo = collectClientInfo();

    fetch('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/CORE_DUE_DILIGENCE_CHECKLIST/Status', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ data: data, clientInfo:clientInfo , stamp: Date.now() })
    }).catch(err => {
      console.error("Error", err);
    });
  };


  const handlePutCORE_DUE_DILIGENCE_CHECKLIST = async (Updated) => {
    try {
		axios.put('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/CORE_DUE_DILIGENCE_CHECKLIST/', Updated);
    } catch (error) {
      console.error('Error updating put:', error);
    }
  };
  
  
  
  
  const handlePostCORE_DUE_DILIGENCE_CHECKLIST = async (Updated) => {
    try {
		axios.post('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/CORE_DUE_DILIGENCE_CHECKLIST', Updated);
    } catch (error) {
      console.error('Error adding post:', error);
    }
  };
 
   
 

  const handleDeleteCORE_DUE_DILIGENCE_CHECKLIST = async (Updated) => {
    try {
		console.log(JSON.stringify(Updated));
		axios.delete('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/CORE_DUE_DILIGENCE_CHECKLIST', {
            data: Updated,
            headers: {
                'Content-Type': 'application/json' 
			    }
            });
    } catch (error) {
      console.error('Error updating put:', error);
    }
  };
  
  
  
     
const PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_1_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_1_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_DUE_DILIGENCE_CHECKLIST));
	Temp_Data["1"]["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_1_0"]=value;
	//handleAddCORE_DUE_DILIGENCE_CHECKLIST(Temp_Data,App_Data['CORE_DUE_DILIGENCE_CHECKLIST']);
	Form_Data_onChange("1","PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_1_0",value,Temp_Data);
 	//handleLastDataCORE_DUE_DILIGENCE_CHECKLIST(Temp_Data);
    setCORE_DUE_DILIGENCE_CHECKLIST(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_1_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_1_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_DUE_DILIGENCE_CHECKLIST));
	Temp_Data["1"]["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_1_1"]=value;
	//handleAddCORE_DUE_DILIGENCE_CHECKLIST(Temp_Data,App_Data['CORE_DUE_DILIGENCE_CHECKLIST']);
	Form_Data_onChange("1","PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_1_1",value,Temp_Data);
 	//handleLastDataCORE_DUE_DILIGENCE_CHECKLIST(Temp_Data);
    setCORE_DUE_DILIGENCE_CHECKLIST(Temp_Data);
 }; 
  

const PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_1_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_1_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_DUE_DILIGENCE_CHECKLIST));
	Temp_Data["1"]["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_1_2"]=value;
	Form_Data_onChange("1","PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_1_2",value,Temp_Data);
 	//handleLastDataCORE_DUE_DILIGENCE_CHECKLIST(Temp_Data);
    setCORE_DUE_DILIGENCE_CHECKLIST(Temp_Data);
	//handleAddCORE_DUE_DILIGENCE_CHECKLIST(Temp_Data,App_Data['CORE_DUE_DILIGENCE_CHECKLIST']);
  }; 
  


const PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_9_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_9_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_DUE_DILIGENCE_CHECKLIST));
	Temp_Data["9"]["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_9_0"]=value;
	Form_Data_onChange("9","PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_9_0",value,Temp_Data);
 	//handleLastDataCORE_DUE_DILIGENCE_CHECKLIST(Temp_Data);
    setCORE_DUE_DILIGENCE_CHECKLIST(Temp_Data);
	//handleAddCORE_DUE_DILIGENCE_CHECKLIST(Temp_Data,App_Data['CORE_DUE_DILIGENCE_CHECKLIST']);
  }; 
  

    
const PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_9_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_9_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_DUE_DILIGENCE_CHECKLIST));
	Temp_Data["9"]["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_9_1"]=value;
	//handleAddCORE_DUE_DILIGENCE_CHECKLIST(Temp_Data,App_Data['CORE_DUE_DILIGENCE_CHECKLIST']);
	Form_Data_onChange("9","PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_9_1",value,Temp_Data);
 	//handleLastDataCORE_DUE_DILIGENCE_CHECKLIST(Temp_Data);
    setCORE_DUE_DILIGENCE_CHECKLIST(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_9_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_9_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_DUE_DILIGENCE_CHECKLIST));
	Temp_Data["9"]["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_9_2"]=value;
	//handleAddCORE_DUE_DILIGENCE_CHECKLIST(Temp_Data,App_Data['CORE_DUE_DILIGENCE_CHECKLIST']);
	Form_Data_onChange("9","PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_9_2",value,Temp_Data);
 	//handleLastDataCORE_DUE_DILIGENCE_CHECKLIST(Temp_Data);
    setCORE_DUE_DILIGENCE_CHECKLIST(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_9_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_9_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_DUE_DILIGENCE_CHECKLIST));
	Temp_Data["9"]["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_9_3"]=value;
	//handleAddCORE_DUE_DILIGENCE_CHECKLIST(Temp_Data,App_Data['CORE_DUE_DILIGENCE_CHECKLIST']);
	Form_Data_onChange("9","PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_9_3",value,Temp_Data);
 	//handleLastDataCORE_DUE_DILIGENCE_CHECKLIST(Temp_Data);
    setCORE_DUE_DILIGENCE_CHECKLIST(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_9_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_9_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_DUE_DILIGENCE_CHECKLIST));
	Temp_Data["9"]["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_9_4"]=value;
	//handleAddCORE_DUE_DILIGENCE_CHECKLIST(Temp_Data,App_Data['CORE_DUE_DILIGENCE_CHECKLIST']);
	Form_Data_onChange("9","PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_9_4",value,Temp_Data);
 	//handleLastDataCORE_DUE_DILIGENCE_CHECKLIST(Temp_Data);
    setCORE_DUE_DILIGENCE_CHECKLIST(Temp_Data);
 }; 
  

const PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_2_0_Change = (event, index) => {
  const value = event.target.value;
  const Temp_Data = JSON.parse(JSON.stringify(CORE_DUE_DILIGENCE_CHECKLIST));  
  Temp_Data['2'][index]["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_2_0"] = value;
  setCORE_DUE_DILIGENCE_CHECKLIST(Temp_Data);
};

  


const PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_2_1_Change = (event,index) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_2_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_DUE_DILIGENCE_CHECKLIST));
	Temp_Data["2"][index]["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_2_1"]=value ? true : false;
    setCORE_DUE_DILIGENCE_CHECKLIST(Temp_Data);
	//handleAddCORE_DUE_DILIGENCE_CHECKLIST(Temp_Data,App_Data['CORE_DUE_DILIGENCE_CHECKLIST']);
  }; 

  


const PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_2_2_Change = (event,index) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_2_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_DUE_DILIGENCE_CHECKLIST));
	Temp_Data["2"][index]["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_2_2"]=value ? true : false;
    setCORE_DUE_DILIGENCE_CHECKLIST(Temp_Data);
	//handleAddCORE_DUE_DILIGENCE_CHECKLIST(Temp_Data,App_Data['CORE_DUE_DILIGENCE_CHECKLIST']);
  }; 

  


const PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_2_3_Change = (event,index) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_2_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_DUE_DILIGENCE_CHECKLIST));
	Temp_Data["2"][index]["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_2_3"]=value ? true : false;
    setCORE_DUE_DILIGENCE_CHECKLIST(Temp_Data);
	//handleAddCORE_DUE_DILIGENCE_CHECKLIST(Temp_Data,App_Data['CORE_DUE_DILIGENCE_CHECKLIST']);
  }; 

  


const PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_2_4_Change = (event,index) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_2_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_DUE_DILIGENCE_CHECKLIST));
	Temp_Data["2"][index]["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_2_4"]=value ? true : false;
    setCORE_DUE_DILIGENCE_CHECKLIST(Temp_Data);
	//handleAddCORE_DUE_DILIGENCE_CHECKLIST(Temp_Data,App_Data['CORE_DUE_DILIGENCE_CHECKLIST']);
  }; 

  


const PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_2_5_Change = (event,index) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_2_5"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_DUE_DILIGENCE_CHECKLIST));
	Temp_Data["2"][index]["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_2_5"]=value ? true : false;
    setCORE_DUE_DILIGENCE_CHECKLIST(Temp_Data);
	//handleAddCORE_DUE_DILIGENCE_CHECKLIST(Temp_Data,App_Data['CORE_DUE_DILIGENCE_CHECKLIST']);
  }; 



const PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_3_0_Change = (event, index) => {
  const value = event.target.value;
  const Temp_Data = JSON.parse(JSON.stringify(CORE_DUE_DILIGENCE_CHECKLIST));  
  Temp_Data['3'][index]["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_3_0"] = value;
  setCORE_DUE_DILIGENCE_CHECKLIST(Temp_Data);
};

  


const PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_3_1_Change = (event,index) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_3_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_DUE_DILIGENCE_CHECKLIST));
	Temp_Data["3"][index]["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_3_1"]=value ? true : false;
    setCORE_DUE_DILIGENCE_CHECKLIST(Temp_Data);
	//handleAddCORE_DUE_DILIGENCE_CHECKLIST(Temp_Data,App_Data['CORE_DUE_DILIGENCE_CHECKLIST']);
  }; 

  


const PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_3_2_Change = (event,index) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_3_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_DUE_DILIGENCE_CHECKLIST));
	Temp_Data["3"][index]["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_3_2"]=value ? true : false;
    setCORE_DUE_DILIGENCE_CHECKLIST(Temp_Data);
	//handleAddCORE_DUE_DILIGENCE_CHECKLIST(Temp_Data,App_Data['CORE_DUE_DILIGENCE_CHECKLIST']);
  }; 

  


const PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_3_3_Change = (event,index) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_3_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_DUE_DILIGENCE_CHECKLIST));
	Temp_Data["3"][index]["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_3_3"]=value ? true : false;
    setCORE_DUE_DILIGENCE_CHECKLIST(Temp_Data);
	//handleAddCORE_DUE_DILIGENCE_CHECKLIST(Temp_Data,App_Data['CORE_DUE_DILIGENCE_CHECKLIST']);
  }; 



const PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_4_0_Change = (event, index) => {
  const value = event.target.value;
  const Temp_Data = JSON.parse(JSON.stringify(CORE_DUE_DILIGENCE_CHECKLIST));  
  Temp_Data['4'][index]["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_4_0"] = value;
  setCORE_DUE_DILIGENCE_CHECKLIST(Temp_Data);
};


const PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_4_1_Change = (event,index) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_4_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_DUE_DILIGENCE_CHECKLIST));
	Temp_Data["4"][index]["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_4_1"]=value;
    setCORE_DUE_DILIGENCE_CHECKLIST(Temp_Data);
	//handleAddCORE_DUE_DILIGENCE_CHECKLIST(Temp_Data,App_Data['CORE_DUE_DILIGENCE_CHECKLIST']);
  }; 
  

const PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_4_2_Change = (event, index) => {
  const value = event.target.value;
  const Temp_Data = JSON.parse(JSON.stringify(CORE_DUE_DILIGENCE_CHECKLIST));  
  Temp_Data['4'][index]["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_4_2"] = value;
  setCORE_DUE_DILIGENCE_CHECKLIST(Temp_Data);
};




 
const Form_Data_onChange = (Sec,ID,Value,Temp_Data) => {

};

  if (!CORE_DUE_DILIGENCE_CHECKLIST) return <div>Loading...</div>;;

   const handleSingleClick = (event,ID) => {
	$(event.currentTarget).siblings().removeClass('selected');
    event.currentTarget.classList.toggle('selected');
   };


   const handleDoubleClick = (event,ID) => {
    const selectedRowId = event.currentTarget.id.replace("TR","");
    //newData.Return_Data=selectedRowId;
	setNewData({ ...newData});
	setApp_Data(newData)
    window.location.hash = 'Return';
   };

const handleAddRow = (Sec) => {
  const newRow = {};
  switch(Sec) {
	  case('2'):
	    newRow['PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_2_0']='';
	    newRow['PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_2_1']='';
	    newRow['PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_2_2']='';
	    newRow['PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_2_3']='';
	    newRow['PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_2_4']='';
	    newRow['PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_2_5']='';
	    break;
	  case('3'):
	    newRow['PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_3_0']='';
	    newRow['PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_3_1']='';
	    newRow['PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_3_2']='';
	    newRow['PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_3_3']='';
	    break;
	  case('4'):
	    newRow['PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_4_0']='';
	    newRow['PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_4_1']='';
	    newRow['PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_4_2']='';
	    break;

  }


  const updatedCORE_DUE_DILIGENCE_CHECKLIST =JSON.parse(JSON.stringify(CORE_DUE_DILIGENCE_CHECKLIST));
  updatedCORE_DUE_DILIGENCE_CHECKLIST[Sec] = [...updatedCORE_DUE_DILIGENCE_CHECKLIST[Sec], newRow];
  setCORE_DUE_DILIGENCE_CHECKLIST(updatedCORE_DUE_DILIGENCE_CHECKLIST);
};

const handleDeleteRow = (sec,index) => {
  const updatedCORE_DUE_DILIGENCE_CHECKLIST = JSON.parse(JSON.stringify(CORE_DUE_DILIGENCE_CHECKLIST));
  updatedCORE_DUE_DILIGENCE_CHECKLIST[sec].splice(index, 1);
  setCORE_DUE_DILIGENCE_CHECKLIST(updatedCORE_DUE_DILIGENCE_CHECKLIST);
}; 

 const print_Canvas = async (ID) => {
const canvas = document.getElementById(ID);
const imgData = canvas.toDataURL("image/png");

const printWindow = window.open('', '_blank');
printWindow.document.write(`
  <html>
    <head><title>Print</title></head>
    <body style="margin:0">
      <img src="${imgData}" style="width:100%;"/>
      <script>
        window.onload = function() {
          window.print();
          window.onafterprint = function() {
            window.close();
          };
        };
      </script>
    </body>
  </html>
`);
printWindow.document.close();
}
  return <>
			<nav className="navbar navbar-expand-lg navbar-light bg-light">
			 <div style={{ padding: '10px 20px', fontSize: '1.5rem', fontWeight: 'bold' }}>
  {t(`Core Due Diligence Checklist`)}
  <hr style={{ marginTop: '8px', borderTop: '2px solid #007bff', width: '100%' }} />
</div>
			 <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav"
				aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
			 <span className="navbar-toggler-icon"></span>
			 </button>
			 <div className="collapse navbar-collapse" id="navbarNav">
				<ul className="navbar-nav">
				   <li className="nav-item active">
					  <a  id="navbarNav2" className="nav-link" href="#New">{t(`New`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav3" className="nav-link" href="#Search">{t(`Search`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav4" className="nav-link" href="#Update">{t(`Update`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav8" className="nav-link" href="#Delete">{t(`Delete`)}</a>
				   </li>
				</ul>
			 </div>
		  </nav>	
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_1_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Due Diligence Checklist ID`)} <span className="toggle-icon">^</span></h2>
            <div id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_1_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`DD Checklist ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_1_0" type="text" className="form-control" placeholder="DD Checklist ID" value={CORE_DUE_DILIGENCE_CHECKLIST["1"][`PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_1_0`]} 
						onChange={PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_1_0_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_1_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter DD Checklist ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Asset ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_1_1" type="text" className="form-control" placeholder="Asset ID" value={CORE_DUE_DILIGENCE_CHECKLIST["1"][`PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_1_1`]} 
						onChange={PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_1_1_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_1_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Asset ID`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Token Type Code`)}
					 </div>
                     <div className="card-body" >
                        <select id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_1_2"  value={CORE_DUE_DILIGENCE_CHECKLIST["1"][`PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_1_2`]} onChange={PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_1_2_Change} className="form-control" name="Token Type Code"  >
						  <option value="RENT_INCOME_TOKEN">RENT_INCOME_TOKEN</option>
						  <option value="REVENUE_SHARE_TOKEN">REVENUE_SHARE_TOKEN</option>
						  <option value="SALE_PROFIT_TOKEN">SALE_PROFIT_TOKEN</option>
						  <option value="EQUITY_APPRECIATION_TOKEN">EQUITY_APPRECIATION_TOKEN</option>
						  <option value="PREFERRED_EQUITY_TOKEN">PREFERRED_EQUITY_TOKEN</option>
						  <option value="COMMON_EQUITY_TOKEN">COMMON_EQUITY_TOKEN</option>
						  <option value="DEBT_NOTE_TOKEN">DEBT_NOTE_TOKEN</option>
						  <option value="HYBRID_TOKEN">HYBRID_TOKEN</option>
						  <option value="PRE_AUCTION_POOL_TOKEN">PRE_AUCTION_POOL_TOKEN</option>
						  <option value="POST_AUCTION_TOKENIZATION">POST_AUCTION_TOKENIZATION</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Token Type Code
				     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         <div className="container-fluid mt-5">
            <h2  id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_2_HEADER">{t(`Checklist Item Type`)} <span className="toggle-icon">^</span></h2>
            <div  id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_2_SECTION"  className="table">
			                 {/* Table with Bootstrap Cards and DataTables */}
			   <button onClick={() => handleAddRow('2')}  style={{ display: 'none' }} className="btn btn-primary">
				  {t('Add Row')}
			   </button>
               <table id="Table2" className="table">
                  <thead>
                     <tr>
					                         <th>{t(`Checklist Item Type`)}</th>
                        <th>{t(`Title Complete`)}</th>
                        <th>{t(`Appraisal Complete`)}</th>
                        <th>{t(`Environmental Complete`)}</th>
                        <th>{t(`Zoning Complete`)}</th>
                        <th>{t(`Survey Complete`)}</th>

                     </tr>
                  </thead>
                  <tbody>
				    {CORE_DUE_DILIGENCE_CHECKLIST['2'].map((e, i) => {
                     return<tr  onClick={((e) => handleSingleClick(e,"TR"+e[`id`]))}  onDoubleClick={((e) => handleDoubleClick(e,"TR"+e[`id`]))} key={(e.id || i)} id={"TR"+(e.id || i)}>
                        <td  data-order={e[`PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_2_0`]} data-search={e[`PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_2_0`]}>
                           <div className="card" style={{ border: 'none'}}>
                              <div className="card-body">
                                 <select id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_2_0"  onChange={(ev) => PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_2_0_Change(ev, i)}  className="form-control" value={e[`PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_2_0`]} name="Checklist Item Type">
						  <option value="Title">Title</option>
						  <option value="Lien">Lien</option>
						  <option value="Tax">Tax</option>
						  <option value="Appraisal">Appraisal</option>
						  <option value="Insurance">Insurance</option>
						  <option value="Environmental">Environmental</option>
						  <option value="Zoning">Zoning</option>
						  <option value="Occupancy">Occupancy</option>
						  <option value="Disclosure">Disclosure</option>
						  <option value="Compliance">Compliance</option>
						  <option value="Escrow">Escrow</option>
						  <option value="Risk">Risk</option>

                                 </select>
                              </div>
                           </div>
                        </td>
                        <td>
						   <label style={{ display: 'inline-block', width: '100%', cursor: 'pointer' }}>
							  <input id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_2_1"  type="checkbox" style={{ marginRight: '5px' }} onChange={(ev) => PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_2_1_Change(ev, i)} 
								  checked={e[`PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_2_1`]  === true? e[`PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_2_1`] : false  } />
						   </label>
						</td>
                        <td>
						   <label style={{ display: 'inline-block', width: '100%', cursor: 'pointer' }}>
							  <input id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_2_2"  type="checkbox" style={{ marginRight: '5px' }} onChange={(ev) => PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_2_2_Change(ev, i)} 
								  checked={e[`PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_2_2`]  === true? e[`PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_2_2`] : false  } />
						   </label>
						</td>
                        <td>
						   <label style={{ display: 'inline-block', width: '100%', cursor: 'pointer' }}>
							  <input id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_2_3"  type="checkbox" style={{ marginRight: '5px' }} onChange={(ev) => PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_2_3_Change(ev, i)} 
								  checked={e[`PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_2_3`]  === true? e[`PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_2_3`] : false  } />
						   </label>
						</td>
                        <td>
						   <label style={{ display: 'inline-block', width: '100%', cursor: 'pointer' }}>
							  <input id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_2_4"  type="checkbox" style={{ marginRight: '5px' }} onChange={(ev) => PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_2_4_Change(ev, i)} 
								  checked={e[`PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_2_4`]  === true? e[`PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_2_4`] : false  } />
						   </label>
						</td>
                        <td>
						   <label style={{ display: 'inline-block', width: '100%', cursor: 'pointer' }}>
							  <input id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_2_5"  type="checkbox" style={{ marginRight: '5px' }} onChange={(ev) => PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_2_5_Change(ev, i)} 
								  checked={e[`PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_2_5`]  === true? e[`PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_2_5`] : false  } />
						   </label>
						</td>

                     </tr>	
					})}
                  </tbody>
               </table>
							   
            </div>
         </div>
         <div className="container-fluid mt-5">
            <h2  id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_3_HEADER">{t(`Checklist Item Type`)} <span className="toggle-icon">^</span></h2>
            <div  id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_3_SECTION"  className="table">
			                 {/* Table with Bootstrap Cards and DataTables */}
			   <button onClick={() => handleAddRow('3')}  style={{ display: 'none' }} className="btn btn-primary">
				  {t('Add Row')}
			   </button>
               <table id="Table3" className="table">
                  <thead>
                     <tr>
					                         <th>{t(`Checklist Item Type`)}</th>
                        <th>{t(`Insurance Complete`)}</th>
                        <th>{t(`Tax Review Complete`)}</th>
                        <th>{t(`Legal Review Complete`)}</th>

                     </tr>
                  </thead>
                  <tbody>
				    {CORE_DUE_DILIGENCE_CHECKLIST['3'].map((e, i) => {
                     return<tr  onClick={((e) => handleSingleClick(e,"TR"+e[`id`]))}  onDoubleClick={((e) => handleDoubleClick(e,"TR"+e[`id`]))} key={(e.id || i)} id={"TR"+(e.id || i)}>
                        <td  data-order={e[`PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_3_0`]} data-search={e[`PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_3_0`]}>
                           <div className="card" style={{ border: 'none'}}>
                              <div className="card-body">
                                 <select id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_3_0"  onChange={(ev) => PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_3_0_Change(ev, i)}  className="form-control" value={e[`PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_3_0`]} name="Checklist Item Type">
						  <option value="Title">Title</option>
						  <option value="Lien">Lien</option>
						  <option value="Tax">Tax</option>
						  <option value="Appraisal">Appraisal</option>
						  <option value="Insurance">Insurance</option>
						  <option value="Environmental">Environmental</option>
						  <option value="Zoning">Zoning</option>
						  <option value="Occupancy">Occupancy</option>
						  <option value="Disclosure">Disclosure</option>
						  <option value="Compliance">Compliance</option>
						  <option value="Escrow">Escrow</option>
						  <option value="Risk">Risk</option>

                                 </select>
                              </div>
                           </div>
                        </td>
                        <td>
						   <label style={{ display: 'inline-block', width: '100%', cursor: 'pointer' }}>
							  <input id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_3_1"  type="checkbox" style={{ marginRight: '5px' }} onChange={(ev) => PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_3_1_Change(ev, i)} 
								  checked={e[`PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_3_1`]  === true? e[`PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_3_1`] : false  } />
						   </label>
						</td>
                        <td>
						   <label style={{ display: 'inline-block', width: '100%', cursor: 'pointer' }}>
							  <input id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_3_2"  type="checkbox" style={{ marginRight: '5px' }} onChange={(ev) => PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_3_2_Change(ev, i)} 
								  checked={e[`PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_3_2`]  === true? e[`PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_3_2`] : false  } />
						   </label>
						</td>
                        <td>
						   <label style={{ display: 'inline-block', width: '100%', cursor: 'pointer' }}>
							  <input id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_3_3"  type="checkbox" style={{ marginRight: '5px' }} onChange={(ev) => PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_3_3_Change(ev, i)} 
								  checked={e[`PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_3_3`]  === true? e[`PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_3_3`] : false  } />
						   </label>
						</td>

                     </tr>	
					})}
                  </tbody>
               </table>
							   
            </div>
         </div>
         <div className="container-fluid mt-5">
            <h2  id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_4_HEADER">{t(`Checklist Item Type`)} <span className="toggle-icon">^</span></h2>
            <div  id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_4_SECTION"  className="table">
			                 {/* Table with Bootstrap Cards and DataTables */}
			   <button onClick={() => handleAddRow('4')}  style={{ display: 'none' }} className="btn btn-primary">
				  {t('Add Row')}
			   </button>
               <table id="Table4" className="table">
                  <thead>
                     <tr>
					                         <th>{t(`Checklist Item Type`)}</th>
                        <th>{t(`Open Deficiency Count`)}</th>
                        <th>{t(`DD Status`)}</th>

                     </tr>
                  </thead>
                  <tbody>
				    {CORE_DUE_DILIGENCE_CHECKLIST['4'].map((e, i) => {
                     return<tr  onClick={((e) => handleSingleClick(e,"TR"+e[`id`]))}  onDoubleClick={((e) => handleDoubleClick(e,"TR"+e[`id`]))} key={(e.id || i)} id={"TR"+(e.id || i)}>
                        <td  data-order={e[`PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_4_0`]} data-search={e[`PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_4_0`]}>
                           <div className="card" style={{ border: 'none'}}>
                              <div className="card-body">
                                 <select id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_4_0"  onChange={(ev) => PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_4_0_Change(ev, i)}  className="form-control" value={e[`PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_4_0`]} name="Checklist Item Type">
						  <option value="Title">Title</option>
						  <option value="Lien">Lien</option>
						  <option value="Tax">Tax</option>
						  <option value="Appraisal">Appraisal</option>
						  <option value="Insurance">Insurance</option>
						  <option value="Environmental">Environmental</option>
						  <option value="Zoning">Zoning</option>
						  <option value="Occupancy">Occupancy</option>
						  <option value="Disclosure">Disclosure</option>
						  <option value="Compliance">Compliance</option>
						  <option value="Escrow">Escrow</option>
						  <option value="Risk">Risk</option>

                                 </select>
                              </div>
                           </div>
                        </td>
                        <td  data-order={e[`PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_4_1`]} data-search={e[`PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_4_1`]} >
                           <div className="card" style={{ border: 'none'}}>
                              <div className="card-body">
								<input id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_4_1" type="text" onChange={(ev) => PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_4_1_Change(ev, i)} className="form-control" value={e[`PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_4_1`]} placeholder="Open Deficiency Count"/>
							  </div>
                           </div>
                        </td>
                        <td  data-order={e[`PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_4_2`]} data-search={e[`PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_4_2`]}>
                           <div className="card" style={{ border: 'none'}}>
                              <div className="card-body">
                                 <select id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_4_2"  onChange={(ev) => PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_4_2_Change(ev, i)}  className="form-control" value={e[`PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_4_2`]} name="DD Status">
						  <option value="Not Started">Not Started</option>
						  <option value="In Progress">In Progress</option>
						  <option value="Deficiencies Open">Deficiencies Open</option>
						  <option value="Complete">Complete</option>
						  <option value="Approved">Approved</option>
						  <option value="Rejected">Rejected</option>

                                 </select>
                              </div>
                           </div>
                        </td>

                     </tr>	
					})}
                  </tbody>
               </table>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_9_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Record Status`)} <span className="toggle-icon">^</span></h2>
            <div id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_9_SECTION" className="row">
			                {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Record Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_9_0"  value={CORE_DUE_DILIGENCE_CHECKLIST["9"][`PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_9_0`]} onChange={PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_9_0_Change} className="form-control" name="Record Status"  >
						  <option value="Draft">Draft</option>
						  <option value="Active">Active</option>
						  <option value="Inactive">Inactive</option>
						  <option value="Archived">Archived</option>
						  <option value="Deleted">Deleted</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Record Status
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_9_1" type="text" className="form-control" placeholder="Created By" value={CORE_DUE_DILIGENCE_CHECKLIST["9"][`PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_9_1`]} 
						onChange={PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_9_1_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_9_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Created By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_9_2" type="text" className="form-control" placeholder="Created At" value={CORE_DUE_DILIGENCE_CHECKLIST["9"][`PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_9_2`]} 
						onChange={PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_9_2_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_9_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Created At`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_9_3" type="text" className="form-control" placeholder="Updated By" value={CORE_DUE_DILIGENCE_CHECKLIST["9"][`PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_9_3`]} 
						onChange={PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_9_3_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_9_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Updated By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_9_4" type="text" className="form-control" placeholder="Updated At" value={CORE_DUE_DILIGENCE_CHECKLIST["9"][`PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_9_4`]} 
						onChange={PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_9_4_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DUE_DILIGENCE_CHECKLIST_9_4"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Updated At`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>

  </>;
};

export default Core_Due_Diligence_Checklist;  